import Otp from './Otp';
import otpStore from './redux';

export { otpStore };
export type { OtpStore } from './types';
export default Otp;
